import(/* webpackMode: "eager" */ "/vercel/path0/src/app/examples/page.jsx");
